import React, { useState } from "react";
import lifeinsurancelic from "../../assets/life-insurance-lic--250x250.svg";
const IPOShowDetails = ({ipoDetails,viewSummarFunc}) => {
    // console.log(ipoDetails)
  
    if(ipoDetails.Indetails){
        ipoDetails = ipoDetails.Indetails
    }else {
        ipoDetails = ipoDetails;
    }
    // console.log(ipoDetails)
    const viewSummaryFunc =() =>{
        viewSummarFunc();
    }

    return(
        <div className="row modifyrowandMobilediv">

        <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
            <div className="newFlexItems">
                <div className="innerImageDiveView_new cursorPointer" >

                    {
                        ipoDetails.ipotime == 'new' &&
                        <div className="postionbadge">
                            <div className="badgearrow">New</div>
                        </div>
                    }

                    <img src={lifeinsurancelic} alt="lifeinsu" className="IPOImg" />
                </div>


                <div className="makeitmiddlealign_new">
                    <p className="ipoNameValue">{ipoDetails.Name}</p>
                    <p className="ipodateRange"> { ipoDetails.BiddingStartDate && ipoDetails.BiddingStartDate.split(",")[0]}-
                      { ipoDetails.BiddingEndDate && ipoDetails.BiddingEndDate.split(",")[0]}</p>
                </div>


                <div className="makeitmiddlealignmore_new">
                    {/* <div className={`ipostatus algincenter mobltop ${ipoDetails.status === "Open" ? 'clrgreen' : (ipoDetails.status === "Closed") ? 'clrorange' : (ipoDetails.status === "Upcoming") ? 'lightred' : ''}`}>
                        {ipoDetails.status}
                    </div> */}
                     {/* <div
                      className={`ipostatus algincenter mobltop ${
                        ipoDetails.OpenStatus === "O"
                          ? "clrgreen"
                          : ipoDetails.OpenStatus === "C"
                          ? "clrorange"
                          : ipoDetails.OpenStatus === "U"
                          ? "lightred"
                          : ""
                      }`}
                    >
                      {ipoDetails.OpenStatus === "O"
                        ? "Open"
                        : ipoDetails.OpenStatus === "C"
                        ? "Closed"
                        : ipoDetails.OpenStatus === "U"
                        ? "Upcoming"
                        : ""}
                    </div> */}
                </div>

            </div>
        </div>

        <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
            <div className="newFlexItems">
                <div className="  algincenter secondpartFlexfirst_details">
                    <p className="ipoNameValue">Lot size</p>
                    <p className="ipodateRange">{ipoDetails.LotSize}</p>
                </div>

                <div className=" algincenter  secondpartFlexsecond_details">
                    <p className="ipoNameValue">Price Range</p>
                    <p className="ipodateRange"> {ipoDetails.MinPrice}-{ipoDetails.MaxPrice}</p>
                </div>
                      {
                          ipoDetails.Categories[0].Applications.length>0 &&
                          <div className="secondpartFlexthirdIPODeails">

                          {
      
                              <div className=" algincenter">
                                  <button className="ipo-list-placeorder" onClick={() => viewSummaryFunc()}>VIEW SUMMARY</button>
      
                              </div>
                          }
                      </div>
                      }
               
            </div>
        </div>
    </div>
    )
}

export default IPOShowDetails;